// AUTO-GENERATED from MEASURED api-client usage by @chilipiper/api-client-shared.
// Do not edit by hand. This file enumerates the api-client services this
// workspace actually reaches at runtime (the reachability analyzer computes the
// set from the import graph, not from package.json declarations).
//
// Verify:     yarn analyze:api-clients --check
// Regenerate: yarn analyze:api-clients --fix
//
// The hand-written `./context.tsx` next to this file imports `Clients`,
// `buildClients`, and `buildMockedClients` to build a typed provider + consumer
// + mocked variants for the workspace.
import type { ApiConfig } from '@chilipiper/api-client-shared'

import { AuthApiClientV1 } from '@chilipiper/api-client-auth'
import { BillingApiClientV1 } from '@chilipiper/api-client-billing'
import { ChatPlatformBuilderApiClientV1 } from '@chilipiper/api-client-chat-platform-builder'
import {
  ChatPlatformChatApiClientV1,
  ChatPlatformChatApiClientV2,
  ChatPlatformChatApiClientV3,
} from '@chilipiper/api-client-chat-platform-chat'
import { ChatPlatformPiperAiApiClientV1 } from '@chilipiper/api-client-chat-platform-piper-ai'
import { ChiliCrmApiClientV1 } from '@chilipiper/api-client-chili-crm'
import { ClayApiClientV1 } from '@chilipiper/api-client-clay'
import {
  ConciergeFireApiClientV1,
  ConciergeFireApiClientV2,
  ConciergeFireApiClientV3,
} from '@chilipiper/api-client-concierge-fire'
import {
  CreditBillingApiClientV1,
  CreditBillingApiClientV2,
  CreditBillingApiClientV3,
  CreditBillingApiClientV4,
} from '@chilipiper/api-client-credit-billing'
import {
  CustomizationSettingsApiClientV1,
  CustomizationSettingsApiClientV2,
} from '@chilipiper/api-client-customization-settings'
import { DistributionApiClientV1 } from '@chilipiper/api-client-distribution'
import { DistroApiClientV1, DistroApiClientV2 } from '@chilipiper/api-client-distro'
import { DynamicTagsApiClientV1 } from '@chilipiper/api-client-dynamic-tags'
import { EmailApiClientV1 } from '@chilipiper/api-client-email'
import { EmailAgentApiClientV1 } from '@chilipiper/api-client-email-agent'
import { EnrichmentApiClientV1 } from '@chilipiper/api-client-enrichment'
import {
  ExternalCalendarApiClientV1,
  ExternalCalendarApiClientV2,
  ExternalCalendarApiClientV3,
} from '@chilipiper/api-client-external-calendar'
import { FirerouterApiClientV1 } from '@chilipiper/api-client-firerouter'
import { GongApiClientV1, GongApiClientV2 } from '@chilipiper/api-client-gong'
import {
  GoogleAuthenticationApiClientV1,
  GoogleAuthenticationApiClientV2,
  GoogleAuthenticationApiClientV3,
} from '@chilipiper/api-client-google-authentication'
import { GotomeetingApiClientV1 } from '@chilipiper/api-client-gotomeeting'
import { HandoffApiClientV1, HandoffApiClientV2 } from '@chilipiper/api-client-handoff'
import { HubspotApiClientV1, HubspotApiClientV2 } from '@chilipiper/api-client-hubspot'
import {
  IntegrationNotificationsApiClientV1,
  IntegrationNotificationsApiClientV2,
} from '@chilipiper/api-client-integration-notifications'
import { KosmotimeApiClientV1 } from '@chilipiper/api-client-kosmotime'
import { MarketoApiClientV1 } from '@chilipiper/api-client-marketo'
import { MeetingPrepApiClientV1 } from '@chilipiper/api-client-meeting-prep'
import {
  MeetingTypesApiClientV1,
  MeetingTypesApiClientV2,
} from '@chilipiper/api-client-meeting-types'
import { MeetingsApiClientV1, MeetingsApiClientV2 } from '@chilipiper/api-client-meetings'
import {
  MeetingsApiApiClientV1,
  MeetingsApiApiClientV3,
  MeetingsApiApiClientV4,
  MeetingsApiApiClientV5,
} from '@chilipiper/api-client-meetings-api'
import { MeetingsCrmApiClientV1, MeetingsCrmApiClientV2 } from '@chilipiper/api-client-meetings-crm'
import {
  MicrosoftAuthenticationApiClientV1,
  MicrosoftAuthenticationApiClientV3,
} from '@chilipiper/api-client-microsoft-authentication'
import {
  MicrosoftTeamsApiClientV1,
  MicrosoftTeamsApiClientV2,
} from '@chilipiper/api-client-microsoft-teams'
import { NotificationsApiClientV1 } from '@chilipiper/api-client-notifications'
import { NotificationsWorkerApiClientV1 } from '@chilipiper/api-client-notifications-worker'
import {
  OrchestratorApiClientV1,
  OrchestratorApiClientV2,
} from '@chilipiper/api-client-orchestrator'
import { PhoneCallerApiClientV1 } from '@chilipiper/api-client-phone-caller'
import { ReportingApiClientV1 } from '@chilipiper/api-client-reporting'
import { RingcentralApiClientV1 } from '@chilipiper/api-client-ringcentral'
import { RulesApiClientV1, RulesApiClientV2 } from '@chilipiper/api-client-rules'
import { RulesLogsApiClientV1 } from '@chilipiper/api-client-rules-logs'
import { SalesforceApiClientV1, SalesforceApiClientV2 } from '@chilipiper/api-client-salesforce'
import {
  TeamSchedulingApiClientV1,
  TeamSchedulingApiClientV2,
  TeamSchedulingApiClientV3,
} from '@chilipiper/api-client-team-scheduling'
import { TeamsApiClientV1 } from '@chilipiper/api-client-teams'
import { TenantApiClientV1 } from '@chilipiper/api-client-tenant'
import { TwilioApiClientV1 } from '@chilipiper/api-client-twilio'
import {
  UserAvailabilityApiClientV1,
  UserAvailabilityApiClientV2,
  UserAvailabilityApiClientV3,
  UserAvailabilityApiClientV4,
} from '@chilipiper/api-client-user-availability'
import { WebDataApiClientV1, WebDataApiClientV2 } from '@chilipiper/api-client-web-data'
import { WebexApiClientV1 } from '@chilipiper/api-client-webex'
import {
  WorkspaceApiClientV1,
  WorkspaceApiClientV2,
  WorkspaceApiClientV3,
  WorkspaceApiClientV4,
  WorkspaceApiClientV5,
} from '@chilipiper/api-client-workspace'
import { ZoomApiClientV1, ZoomApiClientV2 } from '@chilipiper/api-client-zoom'

import { AuthApiClientV1 as AuthApiClientV1Mock } from '@chilipiper/api-client-auth/mocks'
import { BillingApiClientV1 as BillingApiClientV1Mock } from '@chilipiper/api-client-billing/mocks'
import { ChatPlatformBuilderApiClientV1 as ChatPlatformBuilderApiClientV1Mock } from '@chilipiper/api-client-chat-platform-builder/mocks'
import {
  ChatPlatformChatApiClientV1 as ChatPlatformChatApiClientV1Mock,
  ChatPlatformChatApiClientV2 as ChatPlatformChatApiClientV2Mock,
  ChatPlatformChatApiClientV3 as ChatPlatformChatApiClientV3Mock,
} from '@chilipiper/api-client-chat-platform-chat/mocks'
import { ChatPlatformPiperAiApiClientV1 as ChatPlatformPiperAiApiClientV1Mock } from '@chilipiper/api-client-chat-platform-piper-ai/mocks'
import { ChiliCrmApiClientV1 as ChiliCrmApiClientV1Mock } from '@chilipiper/api-client-chili-crm/mocks'
import { ClayApiClientV1 as ClayApiClientV1Mock } from '@chilipiper/api-client-clay/mocks'
import {
  ConciergeFireApiClientV1 as ConciergeFireApiClientV1Mock,
  ConciergeFireApiClientV2 as ConciergeFireApiClientV2Mock,
  ConciergeFireApiClientV3 as ConciergeFireApiClientV3Mock,
} from '@chilipiper/api-client-concierge-fire/mocks'
import {
  CreditBillingApiClientV1 as CreditBillingApiClientV1Mock,
  CreditBillingApiClientV2 as CreditBillingApiClientV2Mock,
  CreditBillingApiClientV3 as CreditBillingApiClientV3Mock,
  CreditBillingApiClientV4 as CreditBillingApiClientV4Mock,
} from '@chilipiper/api-client-credit-billing/mocks'
import {
  CustomizationSettingsApiClientV1 as CustomizationSettingsApiClientV1Mock,
  CustomizationSettingsApiClientV2 as CustomizationSettingsApiClientV2Mock,
} from '@chilipiper/api-client-customization-settings/mocks'
import { DistributionApiClientV1 as DistributionApiClientV1Mock } from '@chilipiper/api-client-distribution/mocks'
import {
  DistroApiClientV1 as DistroApiClientV1Mock,
  DistroApiClientV2 as DistroApiClientV2Mock,
} from '@chilipiper/api-client-distro/mocks'
import { DynamicTagsApiClientV1 as DynamicTagsApiClientV1Mock } from '@chilipiper/api-client-dynamic-tags/mocks'
import { EmailApiClientV1 as EmailApiClientV1Mock } from '@chilipiper/api-client-email/mocks'
import { EmailAgentApiClientV1 as EmailAgentApiClientV1Mock } from '@chilipiper/api-client-email-agent/mocks'
import { EnrichmentApiClientV1 as EnrichmentApiClientV1Mock } from '@chilipiper/api-client-enrichment/mocks'
import {
  ExternalCalendarApiClientV1 as ExternalCalendarApiClientV1Mock,
  ExternalCalendarApiClientV2 as ExternalCalendarApiClientV2Mock,
  ExternalCalendarApiClientV3 as ExternalCalendarApiClientV3Mock,
} from '@chilipiper/api-client-external-calendar/mocks'
import { FirerouterApiClientV1 as FirerouterApiClientV1Mock } from '@chilipiper/api-client-firerouter/mocks'
import {
  GongApiClientV1 as GongApiClientV1Mock,
  GongApiClientV2 as GongApiClientV2Mock,
} from '@chilipiper/api-client-gong/mocks'
import {
  GoogleAuthenticationApiClientV1 as GoogleAuthenticationApiClientV1Mock,
  GoogleAuthenticationApiClientV2 as GoogleAuthenticationApiClientV2Mock,
  GoogleAuthenticationApiClientV3 as GoogleAuthenticationApiClientV3Mock,
} from '@chilipiper/api-client-google-authentication/mocks'
import { GotomeetingApiClientV1 as GotomeetingApiClientV1Mock } from '@chilipiper/api-client-gotomeeting/mocks'
import {
  HandoffApiClientV1 as HandoffApiClientV1Mock,
  HandoffApiClientV2 as HandoffApiClientV2Mock,
} from '@chilipiper/api-client-handoff/mocks'
import {
  HubspotApiClientV1 as HubspotApiClientV1Mock,
  HubspotApiClientV2 as HubspotApiClientV2Mock,
} from '@chilipiper/api-client-hubspot/mocks'
import {
  IntegrationNotificationsApiClientV1 as IntegrationNotificationsApiClientV1Mock,
  IntegrationNotificationsApiClientV2 as IntegrationNotificationsApiClientV2Mock,
} from '@chilipiper/api-client-integration-notifications/mocks'
import { KosmotimeApiClientV1 as KosmotimeApiClientV1Mock } from '@chilipiper/api-client-kosmotime/mocks'
import { MarketoApiClientV1 as MarketoApiClientV1Mock } from '@chilipiper/api-client-marketo/mocks'
import { MeetingPrepApiClientV1 as MeetingPrepApiClientV1Mock } from '@chilipiper/api-client-meeting-prep/mocks'
import {
  MeetingTypesApiClientV1 as MeetingTypesApiClientV1Mock,
  MeetingTypesApiClientV2 as MeetingTypesApiClientV2Mock,
} from '@chilipiper/api-client-meeting-types/mocks'
import {
  MeetingsApiClientV1 as MeetingsApiClientV1Mock,
  MeetingsApiClientV2 as MeetingsApiClientV2Mock,
} from '@chilipiper/api-client-meetings/mocks'
import {
  MeetingsApiApiClientV1 as MeetingsApiApiClientV1Mock,
  MeetingsApiApiClientV3 as MeetingsApiApiClientV3Mock,
  MeetingsApiApiClientV4 as MeetingsApiApiClientV4Mock,
  MeetingsApiApiClientV5 as MeetingsApiApiClientV5Mock,
} from '@chilipiper/api-client-meetings-api/mocks'
import {
  MeetingsCrmApiClientV1 as MeetingsCrmApiClientV1Mock,
  MeetingsCrmApiClientV2 as MeetingsCrmApiClientV2Mock,
} from '@chilipiper/api-client-meetings-crm/mocks'
import {
  MicrosoftAuthenticationApiClientV1 as MicrosoftAuthenticationApiClientV1Mock,
  MicrosoftAuthenticationApiClientV3 as MicrosoftAuthenticationApiClientV3Mock,
} from '@chilipiper/api-client-microsoft-authentication/mocks'
import {
  MicrosoftTeamsApiClientV1 as MicrosoftTeamsApiClientV1Mock,
  MicrosoftTeamsApiClientV2 as MicrosoftTeamsApiClientV2Mock,
} from '@chilipiper/api-client-microsoft-teams/mocks'
import { NotificationsApiClientV1 as NotificationsApiClientV1Mock } from '@chilipiper/api-client-notifications/mocks'
import { NotificationsWorkerApiClientV1 as NotificationsWorkerApiClientV1Mock } from '@chilipiper/api-client-notifications-worker/mocks'
import {
  OrchestratorApiClientV1 as OrchestratorApiClientV1Mock,
  OrchestratorApiClientV2 as OrchestratorApiClientV2Mock,
} from '@chilipiper/api-client-orchestrator/mocks'
import { PhoneCallerApiClientV1 as PhoneCallerApiClientV1Mock } from '@chilipiper/api-client-phone-caller/mocks'
import { ReportingApiClientV1 as ReportingApiClientV1Mock } from '@chilipiper/api-client-reporting/mocks'
import { RingcentralApiClientV1 as RingcentralApiClientV1Mock } from '@chilipiper/api-client-ringcentral/mocks'
import {
  RulesApiClientV1 as RulesApiClientV1Mock,
  RulesApiClientV2 as RulesApiClientV2Mock,
} from '@chilipiper/api-client-rules/mocks'
import { RulesLogsApiClientV1 as RulesLogsApiClientV1Mock } from '@chilipiper/api-client-rules-logs/mocks'
import {
  SalesforceApiClientV1 as SalesforceApiClientV1Mock,
  SalesforceApiClientV2 as SalesforceApiClientV2Mock,
} from '@chilipiper/api-client-salesforce/mocks'
import {
  TeamSchedulingApiClientV1 as TeamSchedulingApiClientV1Mock,
  TeamSchedulingApiClientV2 as TeamSchedulingApiClientV2Mock,
  TeamSchedulingApiClientV3 as TeamSchedulingApiClientV3Mock,
} from '@chilipiper/api-client-team-scheduling/mocks'
import { TeamsApiClientV1 as TeamsApiClientV1Mock } from '@chilipiper/api-client-teams/mocks'
import { TenantApiClientV1 as TenantApiClientV1Mock } from '@chilipiper/api-client-tenant/mocks'
import { TwilioApiClientV1 as TwilioApiClientV1Mock } from '@chilipiper/api-client-twilio/mocks'
import {
  UserAvailabilityApiClientV1 as UserAvailabilityApiClientV1Mock,
  UserAvailabilityApiClientV2 as UserAvailabilityApiClientV2Mock,
  UserAvailabilityApiClientV3 as UserAvailabilityApiClientV3Mock,
  UserAvailabilityApiClientV4 as UserAvailabilityApiClientV4Mock,
} from '@chilipiper/api-client-user-availability/mocks'
import {
  WebDataApiClientV1 as WebDataApiClientV1Mock,
  WebDataApiClientV2 as WebDataApiClientV2Mock,
} from '@chilipiper/api-client-web-data/mocks'
import { WebexApiClientV1 as WebexApiClientV1Mock } from '@chilipiper/api-client-webex/mocks'
import {
  WorkspaceApiClientV1 as WorkspaceApiClientV1Mock,
  WorkspaceApiClientV2 as WorkspaceApiClientV2Mock,
  WorkspaceApiClientV3 as WorkspaceApiClientV3Mock,
  WorkspaceApiClientV4 as WorkspaceApiClientV4Mock,
  WorkspaceApiClientV5 as WorkspaceApiClientV5Mock,
} from '@chilipiper/api-client-workspace/mocks'
import {
  ZoomApiClientV1 as ZoomApiClientV1Mock,
  ZoomApiClientV2 as ZoomApiClientV2Mock,
} from '@chilipiper/api-client-zoom/mocks'

// Real-client surface — what consumer code sees when it calls useApiClient().
export type Clients = {
  auth: AuthApiClientV1
  billing: BillingApiClientV1
  chatPlatformBuilder: ChatPlatformBuilderApiClientV1
  chatPlatformChat: ChatPlatformChatApiClientV1
  chatPlatformChatV2: ChatPlatformChatApiClientV2
  chatPlatformChatV3: ChatPlatformChatApiClientV3
  chatPlatformPiperAi: ChatPlatformPiperAiApiClientV1
  chiliCrm: ChiliCrmApiClientV1
  clay: ClayApiClientV1
  conciergeFire: ConciergeFireApiClientV1
  conciergeFireV2: ConciergeFireApiClientV2
  conciergeFireV3: ConciergeFireApiClientV3
  creditBilling: CreditBillingApiClientV1
  creditBillingV2: CreditBillingApiClientV2
  creditBillingV3: CreditBillingApiClientV3
  creditBillingV4: CreditBillingApiClientV4
  customizationSettings: CustomizationSettingsApiClientV1
  customizationSettingsV2: CustomizationSettingsApiClientV2
  distribution: DistributionApiClientV1
  distro: DistroApiClientV1
  distroV2: DistroApiClientV2
  dynamicTags: DynamicTagsApiClientV1
  email: EmailApiClientV1
  emailAgent: EmailAgentApiClientV1
  enrichment: EnrichmentApiClientV1
  externalCalendar: ExternalCalendarApiClientV1
  externalCalendarV2: ExternalCalendarApiClientV2
  externalCalendarV3: ExternalCalendarApiClientV3
  firerouter: FirerouterApiClientV1
  gong: GongApiClientV1
  gongV2: GongApiClientV2
  googleAuthentication: GoogleAuthenticationApiClientV1
  googleAuthenticationV2: GoogleAuthenticationApiClientV2
  googleAuthenticationV3: GoogleAuthenticationApiClientV3
  gotomeeting: GotomeetingApiClientV1
  handoff: HandoffApiClientV1
  handoffV2: HandoffApiClientV2
  hubspot: HubspotApiClientV1
  hubspotV2: HubspotApiClientV2
  integrationNotifications: IntegrationNotificationsApiClientV1
  integrationNotificationsV2: IntegrationNotificationsApiClientV2
  kosmotime: KosmotimeApiClientV1
  marketo: MarketoApiClientV1
  meetingPrep: MeetingPrepApiClientV1
  meetings: MeetingsApiClientV1
  meetingsApi: MeetingsApiApiClientV1
  meetingsApiV3: MeetingsApiApiClientV3
  meetingsApiV4: MeetingsApiApiClientV4
  meetingsApiV5: MeetingsApiApiClientV5
  meetingsCrm: MeetingsCrmApiClientV1
  meetingsCrmV2: MeetingsCrmApiClientV2
  meetingsV2: MeetingsApiClientV2
  meetingTypes: MeetingTypesApiClientV1
  meetingTypesV2: MeetingTypesApiClientV2
  microsoftAuthentication: MicrosoftAuthenticationApiClientV1
  microsoftAuthenticationV3: MicrosoftAuthenticationApiClientV3
  microsoftTeams: MicrosoftTeamsApiClientV1
  microsoftTeamsV2: MicrosoftTeamsApiClientV2
  notifications: NotificationsApiClientV1
  notificationsWorker: NotificationsWorkerApiClientV1
  orchestrator: OrchestratorApiClientV1
  orchestratorV2: OrchestratorApiClientV2
  phoneCaller: PhoneCallerApiClientV1
  reporting: ReportingApiClientV1
  ringcentral: RingcentralApiClientV1
  rules: RulesApiClientV1
  rulesLogs: RulesLogsApiClientV1
  rulesV2: RulesApiClientV2
  salesforce: SalesforceApiClientV1
  salesforceV2: SalesforceApiClientV2
  teams: TeamsApiClientV1
  teamScheduling: TeamSchedulingApiClientV1
  teamSchedulingV2: TeamSchedulingApiClientV2
  teamSchedulingV3: TeamSchedulingApiClientV3
  tenant: TenantApiClientV1
  twilio: TwilioApiClientV1
  userAvailability: UserAvailabilityApiClientV1
  userAvailabilityV2: UserAvailabilityApiClientV2
  userAvailabilityV3: UserAvailabilityApiClientV3
  userAvailabilityV4: UserAvailabilityApiClientV4
  webData: WebDataApiClientV1
  webDataV2: WebDataApiClientV2
  webex: WebexApiClientV1
  workspace: WorkspaceApiClientV1
  workspaceV2: WorkspaceApiClientV2
  workspaceV3: WorkspaceApiClientV3
  workspaceV4: WorkspaceApiClientV4
  workspaceV5: WorkspaceApiClientV5
  zoom: ZoomApiClientV1
  zoomV2: ZoomApiClientV2
}

// Mock-client surface — exposes per-service test setters (setupX, etc.).
// MockedClients structurally extends Clients (mocks `implements` the real Api),
// so a MockedClients value is assignable to Clients without casting.
export type MockedClients = {
  auth: AuthApiClientV1Mock
  billing: BillingApiClientV1Mock
  chatPlatformBuilder: ChatPlatformBuilderApiClientV1Mock
  chatPlatformChat: ChatPlatformChatApiClientV1Mock
  chatPlatformChatV2: ChatPlatformChatApiClientV2Mock
  chatPlatformChatV3: ChatPlatformChatApiClientV3Mock
  chatPlatformPiperAi: ChatPlatformPiperAiApiClientV1Mock
  chiliCrm: ChiliCrmApiClientV1Mock
  clay: ClayApiClientV1Mock
  conciergeFire: ConciergeFireApiClientV1Mock
  conciergeFireV2: ConciergeFireApiClientV2Mock
  conciergeFireV3: ConciergeFireApiClientV3Mock
  creditBilling: CreditBillingApiClientV1Mock
  creditBillingV2: CreditBillingApiClientV2Mock
  creditBillingV3: CreditBillingApiClientV3Mock
  creditBillingV4: CreditBillingApiClientV4Mock
  customizationSettings: CustomizationSettingsApiClientV1Mock
  customizationSettingsV2: CustomizationSettingsApiClientV2Mock
  distribution: DistributionApiClientV1Mock
  distro: DistroApiClientV1Mock
  distroV2: DistroApiClientV2Mock
  dynamicTags: DynamicTagsApiClientV1Mock
  email: EmailApiClientV1Mock
  emailAgent: EmailAgentApiClientV1Mock
  enrichment: EnrichmentApiClientV1Mock
  externalCalendar: ExternalCalendarApiClientV1Mock
  externalCalendarV2: ExternalCalendarApiClientV2Mock
  externalCalendarV3: ExternalCalendarApiClientV3Mock
  firerouter: FirerouterApiClientV1Mock
  gong: GongApiClientV1Mock
  gongV2: GongApiClientV2Mock
  googleAuthentication: GoogleAuthenticationApiClientV1Mock
  googleAuthenticationV2: GoogleAuthenticationApiClientV2Mock
  googleAuthenticationV3: GoogleAuthenticationApiClientV3Mock
  gotomeeting: GotomeetingApiClientV1Mock
  handoff: HandoffApiClientV1Mock
  handoffV2: HandoffApiClientV2Mock
  hubspot: HubspotApiClientV1Mock
  hubspotV2: HubspotApiClientV2Mock
  integrationNotifications: IntegrationNotificationsApiClientV1Mock
  integrationNotificationsV2: IntegrationNotificationsApiClientV2Mock
  kosmotime: KosmotimeApiClientV1Mock
  marketo: MarketoApiClientV1Mock
  meetingPrep: MeetingPrepApiClientV1Mock
  meetings: MeetingsApiClientV1Mock
  meetingsApi: MeetingsApiApiClientV1Mock
  meetingsApiV3: MeetingsApiApiClientV3Mock
  meetingsApiV4: MeetingsApiApiClientV4Mock
  meetingsApiV5: MeetingsApiApiClientV5Mock
  meetingsCrm: MeetingsCrmApiClientV1Mock
  meetingsCrmV2: MeetingsCrmApiClientV2Mock
  meetingsV2: MeetingsApiClientV2Mock
  meetingTypes: MeetingTypesApiClientV1Mock
  meetingTypesV2: MeetingTypesApiClientV2Mock
  microsoftAuthentication: MicrosoftAuthenticationApiClientV1Mock
  microsoftAuthenticationV3: MicrosoftAuthenticationApiClientV3Mock
  microsoftTeams: MicrosoftTeamsApiClientV1Mock
  microsoftTeamsV2: MicrosoftTeamsApiClientV2Mock
  notifications: NotificationsApiClientV1Mock
  notificationsWorker: NotificationsWorkerApiClientV1Mock
  orchestrator: OrchestratorApiClientV1Mock
  orchestratorV2: OrchestratorApiClientV2Mock
  phoneCaller: PhoneCallerApiClientV1Mock
  reporting: ReportingApiClientV1Mock
  ringcentral: RingcentralApiClientV1Mock
  rules: RulesApiClientV1Mock
  rulesLogs: RulesLogsApiClientV1Mock
  rulesV2: RulesApiClientV2Mock
  salesforce: SalesforceApiClientV1Mock
  salesforceV2: SalesforceApiClientV2Mock
  teams: TeamsApiClientV1Mock
  teamScheduling: TeamSchedulingApiClientV1Mock
  teamSchedulingV2: TeamSchedulingApiClientV2Mock
  teamSchedulingV3: TeamSchedulingApiClientV3Mock
  tenant: TenantApiClientV1Mock
  twilio: TwilioApiClientV1Mock
  userAvailability: UserAvailabilityApiClientV1Mock
  userAvailabilityV2: UserAvailabilityApiClientV2Mock
  userAvailabilityV3: UserAvailabilityApiClientV3Mock
  userAvailabilityV4: UserAvailabilityApiClientV4Mock
  webData: WebDataApiClientV1Mock
  webDataV2: WebDataApiClientV2Mock
  webex: WebexApiClientV1Mock
  workspace: WorkspaceApiClientV1Mock
  workspaceV2: WorkspaceApiClientV2Mock
  workspaceV3: WorkspaceApiClientV3Mock
  workspaceV4: WorkspaceApiClientV4Mock
  workspaceV5: WorkspaceApiClientV5Mock
  zoom: ZoomApiClientV1Mock
  zoomV2: ZoomApiClientV2Mock
}

export const buildClients = (apiConfig: ApiConfig): Clients => ({
  auth: new AuthApiClientV1(apiConfig),
  billing: new BillingApiClientV1(apiConfig),
  chatPlatformBuilder: new ChatPlatformBuilderApiClientV1(apiConfig),
  chatPlatformChat: new ChatPlatformChatApiClientV1(apiConfig),
  chatPlatformChatV2: new ChatPlatformChatApiClientV2(apiConfig),
  chatPlatformChatV3: new ChatPlatformChatApiClientV3(apiConfig),
  chatPlatformPiperAi: new ChatPlatformPiperAiApiClientV1(apiConfig),
  chiliCrm: new ChiliCrmApiClientV1(apiConfig),
  clay: new ClayApiClientV1(apiConfig),
  conciergeFire: new ConciergeFireApiClientV1(apiConfig),
  conciergeFireV2: new ConciergeFireApiClientV2(apiConfig),
  conciergeFireV3: new ConciergeFireApiClientV3(apiConfig),
  creditBilling: new CreditBillingApiClientV1(apiConfig),
  creditBillingV2: new CreditBillingApiClientV2(apiConfig),
  creditBillingV3: new CreditBillingApiClientV3(apiConfig),
  creditBillingV4: new CreditBillingApiClientV4(apiConfig),
  customizationSettings: new CustomizationSettingsApiClientV1(apiConfig),
  customizationSettingsV2: new CustomizationSettingsApiClientV2(apiConfig),
  distribution: new DistributionApiClientV1(apiConfig),
  distro: new DistroApiClientV1(apiConfig),
  distroV2: new DistroApiClientV2(apiConfig),
  dynamicTags: new DynamicTagsApiClientV1(apiConfig),
  email: new EmailApiClientV1(apiConfig),
  emailAgent: new EmailAgentApiClientV1(apiConfig),
  enrichment: new EnrichmentApiClientV1(apiConfig),
  externalCalendar: new ExternalCalendarApiClientV1(apiConfig),
  externalCalendarV2: new ExternalCalendarApiClientV2(apiConfig),
  externalCalendarV3: new ExternalCalendarApiClientV3(apiConfig),
  firerouter: new FirerouterApiClientV1(apiConfig),
  gong: new GongApiClientV1(apiConfig),
  gongV2: new GongApiClientV2(apiConfig),
  googleAuthentication: new GoogleAuthenticationApiClientV1(apiConfig),
  googleAuthenticationV2: new GoogleAuthenticationApiClientV2(apiConfig),
  googleAuthenticationV3: new GoogleAuthenticationApiClientV3(apiConfig),
  gotomeeting: new GotomeetingApiClientV1(apiConfig),
  handoff: new HandoffApiClientV1(apiConfig),
  handoffV2: new HandoffApiClientV2(apiConfig),
  hubspot: new HubspotApiClientV1(apiConfig),
  hubspotV2: new HubspotApiClientV2(apiConfig),
  integrationNotifications: new IntegrationNotificationsApiClientV1(apiConfig),
  integrationNotificationsV2: new IntegrationNotificationsApiClientV2(apiConfig),
  kosmotime: new KosmotimeApiClientV1(apiConfig),
  marketo: new MarketoApiClientV1(apiConfig),
  meetingPrep: new MeetingPrepApiClientV1(apiConfig),
  meetings: new MeetingsApiClientV1(apiConfig),
  meetingsApi: new MeetingsApiApiClientV1(apiConfig),
  meetingsApiV3: new MeetingsApiApiClientV3(apiConfig),
  meetingsApiV4: new MeetingsApiApiClientV4(apiConfig),
  meetingsApiV5: new MeetingsApiApiClientV5(apiConfig),
  meetingsCrm: new MeetingsCrmApiClientV1(apiConfig),
  meetingsCrmV2: new MeetingsCrmApiClientV2(apiConfig),
  meetingsV2: new MeetingsApiClientV2(apiConfig),
  meetingTypes: new MeetingTypesApiClientV1(apiConfig),
  meetingTypesV2: new MeetingTypesApiClientV2(apiConfig),
  microsoftAuthentication: new MicrosoftAuthenticationApiClientV1(apiConfig),
  microsoftAuthenticationV3: new MicrosoftAuthenticationApiClientV3(apiConfig),
  microsoftTeams: new MicrosoftTeamsApiClientV1(apiConfig),
  microsoftTeamsV2: new MicrosoftTeamsApiClientV2(apiConfig),
  notifications: new NotificationsApiClientV1(apiConfig),
  notificationsWorker: new NotificationsWorkerApiClientV1(apiConfig),
  orchestrator: new OrchestratorApiClientV1(apiConfig),
  orchestratorV2: new OrchestratorApiClientV2(apiConfig),
  phoneCaller: new PhoneCallerApiClientV1(apiConfig),
  reporting: new ReportingApiClientV1(apiConfig),
  ringcentral: new RingcentralApiClientV1(apiConfig),
  rules: new RulesApiClientV1(apiConfig),
  rulesLogs: new RulesLogsApiClientV1(apiConfig),
  rulesV2: new RulesApiClientV2(apiConfig),
  salesforce: new SalesforceApiClientV1(apiConfig),
  salesforceV2: new SalesforceApiClientV2(apiConfig),
  teams: new TeamsApiClientV1(apiConfig),
  teamScheduling: new TeamSchedulingApiClientV1(apiConfig),
  teamSchedulingV2: new TeamSchedulingApiClientV2(apiConfig),
  teamSchedulingV3: new TeamSchedulingApiClientV3(apiConfig),
  tenant: new TenantApiClientV1(apiConfig),
  twilio: new TwilioApiClientV1(apiConfig),
  userAvailability: new UserAvailabilityApiClientV1(apiConfig),
  userAvailabilityV2: new UserAvailabilityApiClientV2(apiConfig),
  userAvailabilityV3: new UserAvailabilityApiClientV3(apiConfig),
  userAvailabilityV4: new UserAvailabilityApiClientV4(apiConfig),
  webData: new WebDataApiClientV1(apiConfig),
  webDataV2: new WebDataApiClientV2(apiConfig),
  webex: new WebexApiClientV1(apiConfig),
  workspace: new WorkspaceApiClientV1(apiConfig),
  workspaceV2: new WorkspaceApiClientV2(apiConfig),
  workspaceV3: new WorkspaceApiClientV3(apiConfig),
  workspaceV4: new WorkspaceApiClientV4(apiConfig),
  workspaceV5: new WorkspaceApiClientV5(apiConfig),
  zoom: new ZoomApiClientV1(apiConfig),
  zoomV2: new ZoomApiClientV2(apiConfig),
})

// Mocked variant for tests/storybook. Returns a fully-populated MockedClients
// using each service's default mock; pass `overrides` to replace specific keys.
// Tests that need to call mock-specific setters (e.g. `setupWorkspaces`) should
// destructure from MockedClients rather than Clients.
export const buildMockedClients = (overrides: Partial<MockedClients> = {}): MockedClients => {
  const bridge: Partial<MockedClients> = {}
  const distribution = overrides.distribution ?? new DistributionApiClientV1Mock({ bridge })
  const distro = overrides.distro ?? new DistroApiClientV1Mock({ bridge })
  const rules = overrides.rules ?? new RulesApiClientV1Mock({ bridge })
  const teams = overrides.teams ?? new TeamsApiClientV1Mock()
  bridge.distribution = distribution
  bridge.distro = distro
  bridge.rules = rules
  bridge.teams = teams
  return {
    auth: new AuthApiClientV1Mock(),
    billing: new BillingApiClientV1Mock(),
    chatPlatformBuilder: new ChatPlatformBuilderApiClientV1Mock(),
    chatPlatformChat: new ChatPlatformChatApiClientV1Mock(),
    chatPlatformChatV2: new ChatPlatformChatApiClientV2Mock(),
    chatPlatformChatV3: new ChatPlatformChatApiClientV3Mock(),
    chatPlatformPiperAi: new ChatPlatformPiperAiApiClientV1Mock(),
    chiliCrm: new ChiliCrmApiClientV1Mock(),
    clay: new ClayApiClientV1Mock(),
    conciergeFire: new ConciergeFireApiClientV1Mock(),
    conciergeFireV2: new ConciergeFireApiClientV2Mock(),
    conciergeFireV3: new ConciergeFireApiClientV3Mock(),
    creditBilling: new CreditBillingApiClientV1Mock(),
    creditBillingV2: new CreditBillingApiClientV2Mock(),
    creditBillingV3: new CreditBillingApiClientV3Mock(),
    creditBillingV4: new CreditBillingApiClientV4Mock(),
    customizationSettings: new CustomizationSettingsApiClientV1Mock(),
    customizationSettingsV2: new CustomizationSettingsApiClientV2Mock(),
    distribution,
    distro,
    distroV2: new DistroApiClientV2Mock(),
    dynamicTags: new DynamicTagsApiClientV1Mock(),
    email: new EmailApiClientV1Mock(),
    emailAgent: new EmailAgentApiClientV1Mock(),
    enrichment: new EnrichmentApiClientV1Mock(),
    externalCalendar: new ExternalCalendarApiClientV1Mock(),
    externalCalendarV2: new ExternalCalendarApiClientV2Mock(),
    externalCalendarV3: new ExternalCalendarApiClientV3Mock(),
    firerouter: new FirerouterApiClientV1Mock(),
    gong: new GongApiClientV1Mock(),
    gongV2: new GongApiClientV2Mock(),
    googleAuthentication: new GoogleAuthenticationApiClientV1Mock(),
    googleAuthenticationV2: new GoogleAuthenticationApiClientV2Mock(),
    googleAuthenticationV3: new GoogleAuthenticationApiClientV3Mock(),
    gotomeeting: new GotomeetingApiClientV1Mock(),
    handoff: new HandoffApiClientV1Mock(),
    handoffV2: new HandoffApiClientV2Mock(),
    hubspot: new HubspotApiClientV1Mock(),
    hubspotV2: new HubspotApiClientV2Mock(),
    integrationNotifications: new IntegrationNotificationsApiClientV1Mock(),
    integrationNotificationsV2: new IntegrationNotificationsApiClientV2Mock(),
    kosmotime: new KosmotimeApiClientV1Mock(),
    marketo: new MarketoApiClientV1Mock(),
    meetingPrep: new MeetingPrepApiClientV1Mock(),
    meetings: new MeetingsApiClientV1Mock(),
    meetingsApi: new MeetingsApiApiClientV1Mock(),
    meetingsApiV3: new MeetingsApiApiClientV3Mock(),
    meetingsApiV4: new MeetingsApiApiClientV4Mock(),
    meetingsApiV5: new MeetingsApiApiClientV5Mock(),
    meetingsCrm: new MeetingsCrmApiClientV1Mock(),
    meetingsCrmV2: new MeetingsCrmApiClientV2Mock(),
    meetingsV2: new MeetingsApiClientV2Mock(),
    meetingTypes: new MeetingTypesApiClientV1Mock(),
    meetingTypesV2: new MeetingTypesApiClientV2Mock(),
    microsoftAuthentication: new MicrosoftAuthenticationApiClientV1Mock(),
    microsoftAuthenticationV3: new MicrosoftAuthenticationApiClientV3Mock(),
    microsoftTeams: new MicrosoftTeamsApiClientV1Mock(),
    microsoftTeamsV2: new MicrosoftTeamsApiClientV2Mock(),
    notifications: new NotificationsApiClientV1Mock(),
    notificationsWorker: new NotificationsWorkerApiClientV1Mock(),
    orchestrator: new OrchestratorApiClientV1Mock(),
    orchestratorV2: new OrchestratorApiClientV2Mock(),
    phoneCaller: new PhoneCallerApiClientV1Mock(),
    reporting: new ReportingApiClientV1Mock(),
    ringcentral: new RingcentralApiClientV1Mock(),
    rules,
    rulesLogs: new RulesLogsApiClientV1Mock(),
    rulesV2: new RulesApiClientV2Mock(),
    salesforce: new SalesforceApiClientV1Mock(),
    salesforceV2: new SalesforceApiClientV2Mock(),
    teams,
    teamScheduling: new TeamSchedulingApiClientV1Mock(),
    teamSchedulingV2: new TeamSchedulingApiClientV2Mock(),
    teamSchedulingV3: new TeamSchedulingApiClientV3Mock(),
    tenant: new TenantApiClientV1Mock(),
    twilio: new TwilioApiClientV1Mock(),
    userAvailability: new UserAvailabilityApiClientV1Mock(),
    userAvailabilityV2: new UserAvailabilityApiClientV2Mock(),
    userAvailabilityV3: new UserAvailabilityApiClientV3Mock(),
    userAvailabilityV4: new UserAvailabilityApiClientV4Mock(),
    webData: new WebDataApiClientV1Mock(),
    webDataV2: new WebDataApiClientV2Mock(),
    webex: new WebexApiClientV1Mock(),
    workspace: new WorkspaceApiClientV1Mock(),
    workspaceV2: new WorkspaceApiClientV2Mock(),
    workspaceV3: new WorkspaceApiClientV3Mock(),
    workspaceV4: new WorkspaceApiClientV4Mock(),
    workspaceV5: new WorkspaceApiClientV5Mock(),
    zoom: new ZoomApiClientV1Mock(),
    zoomV2: new ZoomApiClientV2Mock(),
    ...overrides,
  }
}
